import type { ReactNode } from 'react';
import { NavLink } from 'react-router';

/**
 * **Un lien de la navigation permanente, et il dit où l'on est.**
 *
 * `DESIGN.md` : « **le produit dit ce qui s'est passé, sans commenter** », et la densité
 * de l'application est « moyenne » hors du tableau. Un lien actif se distingue donc par
 * **un fond et une graisse**, pas par une couleur d'accent de plus : l'accent violet est
 * réservé à ce qu'on actionne, et une navigation n'est pas une action.
 *
 * **`aria-current` vient de `NavLink` tout seul** quand la route correspond, et c'est ce
 * qui fait qu'une personne au lecteur d'écran entend où elle est. Le style ne le dit qu'à
 * ceux qui voient.
 */
type Props = {
  readonly vers: string;
  readonly children: ReactNode;
};

export function LienDeNavigation({ vers, children }: Props) {
  return (
    <NavLink
      to={vers}
      className={({ isActive }) =>
        [
          'rounded-2 px-3 py-2 text-14 transition-colors duration-1',
          isActive
            ? 'bg-fond-bloc font-weight-700 text-texte-fort'
            : 'font-weight-500 text-texte-faible hover:text-texte-fort',
        ].join(' ')
      }
    >
      {children}
    </NavLink>
  );
}
